import { Component, EventEmitter, Inject, Input, Optional, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-patient-transfer-info',
  templateUrl: './patient-transfer-info.component.html',
  styleUrls: ['./patient-transfer-info.component.scss'],
  standalone: false
})
export class PatientTransferInfoComponent {
  @Input() patientId = '';
  @Input() patientName = '';
  @Input() dateOfBirth = '';
  @Input() gender = '';
  @Input() sourceFacility = '';
  @Input() targetFacility = '';

  @Output() continued = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  faviconError = false;

  constructor(
    @Optional() private dialogRef: MatDialogRef<PatientTransferInfoComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) data: any,
  ) {
    if (data) {
      this.patientId = data.patientId ?? '';
      this.patientName = data.patientName ?? '';
      this.dateOfBirth = data.dateOfBirth ?? '';
      this.gender = data.gender ?? '';
      this.sourceFacility = data.sourceFacility ?? '';
      this.targetFacility = data.targetFacility ?? '';
    }
  }

  onContinue(): void {
    this.continued.emit();
    this.dialogRef?.close('continue');
  }

  onCancel(): void {
    this.cancelled.emit();
    this.dialogRef?.close();
  }
}
